export default __webpack_public_path__ + "static/media/startupRealCase1-mobile-en.b29eca2e.jpg";